import { COLORS } from '@laerdal/life-react-components';
import React from 'react';
import styled from 'styled-components';

interface SamaritanButtonProps {
  text: string;
  disabled?: boolean;
  onClick?: () => void;
}

const SamaritanButton = styled.button<{ disabled?: boolean }>`
  position: relative;
  padding: 6px 8px;
  background: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;

  /* Gradient border via background trick on a wrapper */
  border: 2px solid transparent;
  background-image: ${({ disabled }) =>
    disabled
      ? `linear-gradient(white, white), linear-gradient(to bottom, var(--life-color-text-disabled), var(--life-color-text-disabled))`
      : `linear-gradient(white, white), linear-gradient(to bottom, #AF50AF, #5F73BA)`};
  background-origin: border-box;
  background-clip: padding-box, border-box;

  &:hover {
    background-image: linear-gradient(${COLORS.primary_20}, ${COLORS.primary_20}), linear-gradient(to bottom, #AF50AF, #5F73BA);
  }

  &:active {
    background-image: linear-gradient(${COLORS.primary_50}, ${COLORS.primary_50}), linear-gradient(to bottom, #AF50AF, #5F73BA);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg path {
    fill: ${({ disabled }) =>
      disabled ? 'var(--life-color-text-disabled)' : 'var(--life-color-text-samaritan)'};
  }
`;

const ButtonText = styled.span<{ disabled?: boolean }>`
  padding: 0 4px;
  color: ${({ disabled }) =>
    disabled ? 'var(--life-color-text-disabled)' : 'var(--life-color-text-samaritan)'};
  text-align: center;
  font-feature-settings: 'liga' off;
  /* Components/Bold/S */
  font-family: var(--font-family-Lato, Lato);
  font-size: var(--font-size-6, 16px);
  font-style: normal;
  font-weight: var(--font-weight-bold, 700);
  line-height: var(--line-height-14, 20px); /* 125% */
`;

const SamaritanButtonComponent = ({ text, disabled, onClick }: SamaritanButtonProps) => {
  return <SamaritanButton disabled={disabled} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.0487 14.0632C15.0356 14.0767 15.0224 14.0902 15.0091 14.1035L11.6244 17.4882C10.7275 18.3851 9.27327 18.3851 8.37633 17.4882L2.92931 12.0412C0.976689 10.0885 0.976688 6.9227 2.92931 4.97008C4.8818 3.01759 8.04735 3.01746 10 4.96971C11.9526 3.01746 15.1182 3.01758 17.0707 4.97008C19.0233 6.9227 19.0233 10.0885 17.0707 12.0411L15.0487 14.0632ZM11.1789 6.1486L8.73173 8.59575C8.24357 9.08391 8.24357 9.87536 8.73173 10.3635C9.21988 10.8517 10.0113 10.8517 10.4995 10.3635L10.8843 9.97876C12.0233 8.83973 13.87 8.83973 15.0091 9.97876C15.3252 10.2949 15.5536 10.6656 15.6943 11.0605L15.8922 10.8626C17.1939 9.56089 17.1939 7.45034 15.8922 6.14859C14.5906 4.84697 12.4807 4.84722 11.1789 6.1486ZM13.8563 12.8985L12.885 13.8699C12.8778 13.877 12.8708 13.8843 12.864 13.8916L10.4459 16.3097C10.1999 16.5557 9.80091 16.5557 9.55484 16.3097L4.10782 10.8626C2.80607 9.56089 2.80607 7.45034 4.10782 6.14859C5.40957 4.84685 7.52012 4.84685 8.82186 6.1486L7.55322 7.41724C6.41419 8.55627 6.41419 10.403 7.55322 11.542C8.69225 12.6811 10.539 12.6811 11.678 11.542L12.0628 11.1573C12.5509 10.6691 13.3424 10.6691 13.8305 11.1573C14.3099 11.6367 14.3185 12.4086 13.8563 12.8985Z" fill="var(--life-color-text-samaritan)"/>
      </svg>
      <ButtonText disabled={disabled}>{text}</ButtonText>
    </SamaritanButton>;
};

export default SamaritanButtonComponent;
